import { render, staticRenderFns } from "./microsoft.vue?vue&type=template&id=8f4d6024&"
import script from "./microsoft.vue?vue&type=script&lang=js&"
export * from "./microsoft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f4d6024')) {
      api.createRecord('8f4d6024', component.options)
    } else {
      api.reload('8f4d6024', component.options)
    }
    module.hot.accept("./microsoft.vue?vue&type=template&id=8f4d6024&", function () {
      api.rerender('8f4d6024', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/microsoft.vue"
export default component.exports